(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oonote-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.oonoteInitialized === 'true') return;
    root.dataset.oonoteInitialized = 'true';
    root.querySelectorAll('.family-image > img, .product-hero, .shop-photo > img').forEach(image=>image.setAttribute('data-oonote-ui', ''));
    const lifecycle = new AbortController();
    const strings = JSON.parse(root.querySelector('[data-oonote-translations]').textContent);


    const menu=root.querySelector('.menu-toggle'),nav=root.querySelector('.nav');
    function closeMenu(){nav.classList.remove('open');menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',strings["ouvrir_le_menu"])}
    menu.addEventListener('click',()=>{const open=nav.classList.toggle('open');menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?strings["fermer_le_menu"]:strings["ouvrir_le_menu"])});
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeMenu()},{signal:lifecycle.signal});
    let audioContext,activeVoice,toneRequest=0,soundEnabled=true;
    const pitches={Do:261.63,'Ré':293.66,Mi:329.63,Fa:349.23,Sol:392,La:440,SolGrave:196};

    const clickMelody=[
      ['Mi',1],['Mi',1],['Fa',1],['Sol',1],['Sol',1],['Fa',1],['Mi',1],['Ré',1],
      ['Do',1],['Do',1],['Ré',1],['Mi',1],['Mi',1.5],['Ré',.5],['Ré',2],
      ['Mi',1],['Mi',1],['Fa',1],['Sol',1],['Sol',1],['Fa',1],['Mi',1],['Ré',1],
      ['Do',1],['Do',1],['Ré',1],['Mi',1],['Ré',1.5],['Do',.5],['Do',2]
    ].map(([pitch,beats])=>({name:pitch==='SolGrave'?'Sol':pitch,hz:pitches[pitch],duration:.44*beats}));
    let melodyIndex=0,lastMelodyClick=0;
    function nextMelodyNote(){
      const now=performance.now();if(now-lastMelodyClick>4000)melodyIndex=0;
      const note=clickMelody[melodyIndex];melodyIndex=(melodyIndex+1)%clickMelody.length;lastMelodyClick=now;return note;
    }
    function stopVoice(){
      if(!activeVoice||!audioContext)return;
      const t=audioContext.currentTime,voice=activeVoice;activeVoice=null;
      if(voice.gain.gain.cancelAndHoldAtTime)voice.gain.gain.cancelAndHoldAtTime(t);
      else{const level=voice.gain.gain.value;voice.gain.gain.cancelScheduledValues(t);voice.gain.gain.setValueAtTime(level,t)}
      voice.gain.gain.setTargetAtTime(0,t,.004);
      voice.oscillators.forEach(oscillator=>oscillator.stop(t+.025));
    }

    const soundToggle=root.querySelector('#sound-toggle');
    try{soundEnabled=localStorage.getItem('oonote-sound')!=='off'}catch(e){}
    function updateSoundToggle(){soundToggle.setAttribute('aria-pressed',String(soundEnabled));soundToggle.setAttribute('aria-label',soundEnabled?strings["couper_le_son"]:strings["activer_le_son"]);soundToggle.querySelector('span').textContent=soundEnabled?strings["son_discret"]:strings["son_coupe"]}
    soundToggle.addEventListener('click',()=>{soundEnabled=!soundEnabled;melodyIndex=0;lastMelodyClick=0;if(!soundEnabled)stopAllSounds();updateSoundToggle();try{localStorage.setItem('oonote-sound',soundEnabled?'on':'off')}catch(e){}});
    updateSoundToggle();
    const soundProfiles={ambient:{instrument:'guitar',volume:.035,attack:.002,harmonics:[[1,.74],[2,.52],[3,.33],[4,.18],[5,.12],[6,.09],[7,.06],[8,.04]]}};
    async function playTone(note,duration=.44,profile=soundProfiles.ambient){
      const request=++toneRequest;if(!soundEnabled)return false;
      const AC=window.AudioContext||window.webkitAudioContext;if(!AC)throw new Error('Audio unavailable');
      audioContext=audioContext||new AC();if(audioContext.state!=='running')await audioContext.resume();
      if(request!==toneRequest||!soundEnabled)return false;
      stopVoice();
      const t=audioContext.currentTime,envelope=audioContext.createGain(),voice={gain:envelope,oscillators:[]};
      activeVoice=voice;

      const guitar=profile.instrument==='guitar';
      envelope.gain.setValueAtTime(0,t);envelope.gain.linearRampToValueAtTime(profile.volume,t+profile.attack);
      if(guitar)envelope.gain.exponentialRampToValueAtTime(profile.volume*.5,t+.065);
      if(profile===soundProfiles.quiz)envelope.gain.exponentialRampToValueAtTime(profile.volume*.4,t+.14);
      envelope.gain.exponentialRampToValueAtTime(.0001,t+duration);envelope.connect(audioContext.destination);
      let remaining=profile.harmonics.length+(guitar?1:0);
      const release=(source,gain)=>{source.disconnect();gain.disconnect();if(--remaining===0){envelope.disconnect();if(activeVoice===voice)activeVoice=null}};
      profile.harmonics.forEach(([multiple,level])=>{
        const oscillator=audioContext.createOscillator(),harmonic=audioContext.createGain();
        oscillator.type='sine';oscillator.frequency.value=note.hz*multiple;harmonic.gain.setValueAtTime(level,t);

        if(guitar&&multiple>1)harmonic.gain.exponentialRampToValueAtTime(level*.015,t+Math.min(duration,.18/Math.sqrt(multiple)));
        if(profile===soundProfiles.quiz&&multiple>1)harmonic.gain.exponentialRampToValueAtTime(level*.08,t+duration/multiple);
        oscillator.connect(harmonic);harmonic.connect(envelope);voice.oscillators.push(oscillator);oscillator.start(t);oscillator.stop(t+duration+.025);
        oscillator.onended=()=>release(oscillator,harmonic);
      });
      if(guitar){

        const buffer=audioContext.createBuffer(1,Math.ceil(audioContext.sampleRate*.007),audioContext.sampleRate),samples=buffer.getChannelData(0);
        for(let i=0;i<samples.length;i++)samples[i]=(Math.random()*2-1)*(1-i/samples.length)**2;
        const pick=audioContext.createBufferSource(),pickGain=audioContext.createGain();pick.buffer=buffer;pickGain.gain.value=.07;
        pick.connect(pickGain);pickGain.connect(envelope);voice.oscillators.push(pick);pick.onended=()=>release(pick,pickGain);pick.start(t);
      }
      return true;
    }
    function showClickNote(event,note){
      const target=event.target instanceof Element?event.target:root,rect=target.getBoundingClientRect();
      const keyboard=event.detail===0&&event.clientX===0&&event.clientY===0;
      const x=keyboard?rect.left+rect.width/2:event.clientX,y=keyboard?rect.top+rect.height/2:event.clientY;
      const mark=document.createElement('span');mark.className='click-note';mark.setAttribute('aria-hidden','true');
      mark.style.left=x+'px';mark.style.top=y+'px';
      const symbol=document.createElement('span'),name=document.createElement('span');symbol.className='click-note-symbol';symbol.textContent='♪';name.className='click-note-name';name.textContent=note.name;
      mark.append(symbol,name);root.append(mark);setTimeout(()=>mark.remove(),440);
    }

function createQuizAudio({ getContext }) {
  const SAMPLE_ROOT = 'https://gleitz.github.io/midi-js-soundfonts/FluidR3_GM/';
  const profiles = Object.freeze({
    piano: { sample: 'acoustic_grand_piano', attack: 0.006, release: 0.32, sustain: false,
      harmonics: [1, 0.34, 0.17, 0.09, 0.055, 0.025], cutoff: 6200, vibrato: 0 },
    cello: { sample: 'cello', attack: 0.035, release: 0.44, sustain: true,
      harmonics: [1, 0.76, 0.59, 0.35, 0.23, 0.17, 0.12, 0.08, 0.05], cutoff: 3400, vibrato: 3.4 },
    violin: { sample: 'violin', attack: 0.024, release: 0.31, sustain: true,
      harmonics: [1, 0.84, 0.61, 0.54, 0.39, 0.28, 0.19, 0.15, 0.11, 0.07], cutoff: 5700, vibrato: 4.2 },
    bassoon: { sample: 'bassoon', attack: 0.025, release: 0.25, sustain: true,
      harmonics: [1, 0.23, 0.73, 0.18, 0.45, 0.14, 0.2, 0.09, 0.12], cutoff: 2800, vibrato: 1.2 }
  });
  const noteNames = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
  const cache = new Map();
  const voices = new Set();
  const handles = new WeakMap();
  const waves = new WeakMap();
  const controllers = new Set();
  const stats = { requests: 0, loaded: 0, failed: 0, sampleStarts: 0, synthStarts: 0 };
  let destroyed = false;
  let nextId = 0;
  let epoch = 0;

  function pitchOf(note) {
    let midi;
    if (typeof note === 'number') midi = note <= 127 ? note : 69 + 12 * Math.log2(note / 440);
    else if (typeof note === 'object' && note) {
      if (Number.isFinite(note.midi)) midi = note.midi;
      else if (typeof note.pitch === 'string') return pitchOf(note.pitch);
      else if (Number.isFinite(note.hz) && note.hz > 0) midi = 69 + 12 * Math.log2(note.hz / 440);
      else if (typeof note.id === 'string') return pitchOf(note.id);
    } else if (typeof note === 'string') {
      const match = /^([A-Ga-g])([#b♯♭]?)(-?\d+)$/.exec(note.trim());
      if (match) {
        midi = ({ C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 })[match[1].toUpperCase()]
          + (Number(match[3]) + 1) * 12 + (/[#♯]/.test(match[2]) ? 1 : /[b♭]/.test(match[2]) ? -1 : 0);
      }
    }
    if (!Number.isFinite(midi) || midi < 21 || midi > 108) return null;
    const rounded = Math.round(midi);
    return { midi, hz: 440 * Math.pow(2, (midi - 69) / 12),
      filename: noteNames[rounded % 12] + (Math.floor(rounded / 12) - 1), rounded };
  }

  function instrumentOf(instrument) {
    return Object.prototype.hasOwnProperty.call(profiles, instrument) ? instrument : 'piano';
  }

  function cachedSample(instrument, pitch) {
    return cache.get(instrument + ':' + pitch.rounded);
  }


  function sustainBuffer(ctx, input) {
    if (input.duration < 0.95) return { buffer: input, loopStart: 0, loopEnd: 0 };
    const rate = input.sampleRate;
    const start = Math.round(0.38 * rate);
    const end = Math.round(0.88 * rate);
    const fade = Math.round(0.028 * rate);
    const result = ctx.createBuffer(input.numberOfChannels, end + 1, rate);
    for (let ch = 0; ch < input.numberOfChannels; ch += 1) {
      const original = input.getChannelData(ch);
      const data = result.getChannelData(ch);
      data.set(original.subarray(0, end + 1));
      for (let i = 0; i < fade; i += 1) {
        const blend = (i + 1) / fade;
        data[end - fade + i] = original[end - fade + i] * (1 - blend) + original[start - fade + i] * blend;
      }
    }
    return { buffer: result, loopStart: start / rate, loopEnd: end / rate };
  }

  function sampleLevel(buffer) {
    let energy = 0;
    let count = 0;
    let peak = 0;
    const from = Math.round(0.10 * buffer.sampleRate);
    const to = Math.min(buffer.length, Math.round(0.85 * buffer.sampleRate));
    for (let ch = 0; ch < buffer.numberOfChannels; ch += 1) {
      const data = buffer.getChannelData(ch);
      for (let i = from; i < to; i += 2) {
        const value = data[i];
        energy += value * value;
        peak = Math.max(peak, Math.abs(value));
        count += 1;
      }
    }

    const rms = Math.sqrt(energy / Math.max(1, count));
    return Math.min(0.058 / Math.max(0.01, rms), 0.19 / Math.max(0.02, peak), 3.5);
  }

  function loadSample(ctx, instrument, pitch) {
    const key = instrument + ':' + pitch.rounded;
    const existing = cache.get(key);
    if (existing) return existing.promise;
    if (destroyed || typeof fetch !== 'function') return Promise.resolve(null);
    const entry = { status: 'loading', sample: null, promise: null };
    cache.set(key, entry);
    const controller = new AbortController();
    controllers.add(controller);
    const timeout = setTimeout(() => controller.abort(), 6500);
    stats.requests += 1;
    entry.promise = (async () => {
      try {
        const url = SAMPLE_ROOT + profiles[instrument].sample + '-mp3/' + pitch.filename + '.mp3';
        const response = await fetch(url, { signal: controller.signal, mode: 'cors', credentials: 'omit', cache: 'force-cache' });
        if (!response.ok) throw new Error(strings["sample_unavailable"]);
        const bytes = await response.arrayBuffer();
        if (destroyed) return null;
        const decoded = await ctx.decodeAudioData(bytes);
        if (destroyed) return null;
        const level = sampleLevel(decoded);
        const source = profiles[instrument].sustain ? sustainBuffer(ctx, decoded) : { buffer: decoded, loopStart: 0, loopEnd: 0 };
        entry.sample = { ...source, level };
        entry.status = 'ready';
        stats.loaded += 1;
        return entry.sample;
      } catch (_) {
        entry.status = 'failed';
        stats.failed += 1;
        return null;
      } finally {
        clearTimeout(timeout);
        controllers.delete(controller);
      }
    })();
    return entry.promise;
  }

  function prepare(instrument, pitches) {
    if (destroyed) return Promise.resolve({ loaded: 0, requested: 0 });
    const name = instrumentOf(instrument);
    const unique = new Map();
    for (const note of pitches || []) {
      const pitch = pitchOf(note);
      if (pitch) unique.set(pitch.rounded, pitch);
    }
    let context;
    try { context = getContext(); } catch (_) { return Promise.resolve({ loaded: 0, requested: unique.size }); }

    return Promise.resolve(context).then(async ctx => {
      if (!ctx || ctx.state === 'closed' || destroyed) return { loaded: 0, requested: unique.size };
      const queue = Array.from(unique.values());
      let loaded = 0;
      let cursor = 0;
      const worker = async () => {
        while (cursor < queue.length && !destroyed) {
          const pitch = queue[cursor++];
          if (await loadSample(ctx, name, pitch)) loaded += 1;
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
      return { loaded, requested: unique.size };
    }).catch(() => ({ loaded: 0, requested: unique.size }));
  }

  function disconnect(voice) {
    if (voice.cleaned) return;
    voice.cleaned = true;
    clearTimeout(voice.watchdog);
    clearTimeout(voice.cleanupTimer);
    for (const node of voice.nodes) { try { node.disconnect(); } catch (_) {} }
    voices.delete(voice);
  }

  function stopSources(voice, when) {
    for (const node of voice.sources) { try { node.stop(when); } catch (_) {} }
  }

  function gainAt(voice, time) {
    const elapsed = Math.max(0, time - voice.startTime);
    if (elapsed < voice.profile.attack) return voice.level * elapsed / voice.profile.attack;
    if (voice.instrument === 'piano') return voice.level * Math.pow(0.3, Math.min(4, elapsed - voice.profile.attack) / 1.2);
    return voice.level;
  }

  function releaseVoice(voice, fast = false) {
    if (!voice || voice.cleaned || voice.released) return;
    voice.released = true;
    clearTimeout(voice.watchdog);
    if (!voice.output) { voices.delete(voice); return; }
    const now = voice.ctx.currentTime;
    const when = fast ? now : Math.max(now, voice.startTime + 0.075);
    const duration = fast ? 0.025 : voice.profile.release;
    const gain = voice.output.gain;

    gain.cancelScheduledValues(when);
    gain.setValueAtTime(Math.max(0.0001, gainAt(voice, when)), when);
    gain.exponentialRampToValueAtTime(0.0001, when + duration);
    stopSources(voice, when + duration + 0.015);
    voice.cleanupTimer = setTimeout(() => disconnect(voice), Math.max(0, (when + duration + 0.09 - now) * 1000));
  }

  function waveFor(ctx, instrument) {
    let byInstrument = waves.get(ctx);
    if (!byInstrument) { byInstrument = new Map(); waves.set(ctx, byInstrument); }
    if (!byInstrument.has(instrument)) {
      const harmonics = profiles[instrument].harmonics;
      const real = new Float32Array(harmonics.length + 1);
      const imaginary = new Float32Array(harmonics.length + 1);
      harmonics.forEach((amplitude, i) => { imaginary[i + 1] = amplitude; });
      byInstrument.set(instrument, ctx.createPeriodicWave(real, imaginary));
    }
    return byInstrument.get(instrument);
  }

  function playVoice(voice, ctx) {
    if (voice.released || destroyed || voice.epoch !== epoch || ctx.state !== 'running') return;
    voice.ctx = ctx;
    voice.startTime = ctx.currentTime;
    const profile = voice.profile;
    const entry = cachedSample(voice.instrument, voice.pitch);
    const sample = entry && entry.sample;
    const gain = ctx.createGain();
    voice.output = gain;
    voice.nodes.push(gain);
    voice.level = (sample ? sample.level : 0.13) * voice.velocity;
    gain.gain.setValueAtTime(0.0001, voice.startTime);
    gain.gain.linearRampToValueAtTime(voice.level, voice.startTime + profile.attack);
    if (voice.instrument === 'piano') {
      gain.gain.exponentialRampToValueAtTime(voice.level * Math.pow(0.3, 4 / 1.2), voice.startTime + profile.attack + 4);
    }
    gain.connect(ctx.destination);
    if (sample) {
      const source = ctx.createBufferSource();
      source.buffer = sample.buffer;
      source.playbackRate.value = Math.pow(2, (voice.pitch.midi - voice.pitch.rounded) / 12);
      if (sample.loopEnd > sample.loopStart) {
        source.loop = true;
        source.loopStart = sample.loopStart;
        source.loopEnd = sample.loopEnd;
      }
      source.connect(gain);
      voice.nodes.push(source);
      voice.sources.push(source);
      source.onended = () => disconnect(voice);
      source.start();
      stats.sampleStarts += 1;
      voice.mode = 'sample';
    } else {
      const oscillator = ctx.createOscillator();
      const filter = ctx.createBiquadFilter();
      oscillator.frequency.value = voice.pitch.hz;
      oscillator.setPeriodicWave(waveFor(ctx, voice.instrument));
      filter.type = 'lowpass';
      filter.frequency.value = Math.min(profile.cutoff, voice.pitch.hz * (voice.instrument === 'bassoon' ? 8 : 12));
      filter.Q.value = 0.5;
      oscillator.connect(filter);
      filter.connect(gain);
      voice.nodes.push(oscillator, filter);
      voice.sources.push(oscillator);
      if (profile.vibrato) {
        const vibrato = ctx.createOscillator();
        const amount = ctx.createGain();
        vibrato.frequency.value = voice.instrument === 'cello' ? 4.9 : 5.4;
        amount.gain.setValueAtTime(0, voice.startTime);
        amount.gain.linearRampToValueAtTime(profile.vibrato, voice.startTime + 0.22);
        vibrato.connect(amount);
        amount.connect(oscillator.detune);
        voice.nodes.push(vibrato, amount);
        voice.sources.push(vibrato);
        vibrato.start();
      }
      oscillator.onended = () => disconnect(voice);
      oscillator.start();
      stats.synthStarts += 1;
      voice.mode = 'synth';

      void loadSample(ctx, voice.instrument, voice.pitch);
    }

    voice.watchdog = setTimeout(() => releaseVoice(voice), 5500);
  }

  function start(note, { instrument = 'piano', velocity = 0.85 } = {}) {
    const handle = { id: ++nextId, ready: null };
    const pitch = pitchOf(note);
    const name = instrumentOf(instrument);
    const voice = { handle, pitch, instrument: name, profile: profiles[name],
      velocity: Math.max(0.15, Math.min(1, Number.isFinite(velocity) ? velocity : 0.85)),
      epoch, released: false, cleaned: false, output: null, nodes: [], sources: [], mode: 'pending' };
    handles.set(handle, voice);
    if (destroyed || !pitch) {
      voice.released = true;
      handle.ready = Promise.resolve(handle);
      return handle;
    }

    while (voices.size >= 4) {
      const oldest = voices.values().next().value;
      if (oldest.released && oldest.ctx) {
        const now = oldest.ctx.currentTime;
        oldest.output.gain.cancelScheduledValues(now);
        oldest.output.gain.setTargetAtTime(0.0001, now, 0.008);
        stopSources(oldest, now + 0.04);
      } else releaseVoice(oldest, true);
      voices.delete(oldest);
    }
    voices.add(voice);
    try {
      const context = getContext();

      const resume = context && context.state === 'suspended' ? context.resume() : null;
      handle.ready = Promise.resolve(resume).then(() => {
        if (context && !voice.released && !destroyed && voice.epoch === epoch) playVoice(voice, context);
        if (!voice.output) voices.delete(voice);
        return handle;
      }).catch(() => { voice.released = true; disconnect(voice); return handle; });
    } catch (_) {
      voice.released = true;
      disconnect(voice);
      handle.ready = Promise.resolve(handle);
    }
    return handle;
  }

  function release(handle) { releaseVoice(handles.get(handle)); }
  function stopAll() {
    epoch += 1;
    for (const voice of Array.from(voices)) {
      if (voice.released && voice.output) {
        const now = voice.ctx.currentTime;
        voice.output.gain.cancelScheduledValues(now);
        voice.output.gain.setTargetAtTime(0.0001, now, 0.008);
        stopSources(voice, now + 0.04);
      } else releaseVoice(voice, true);
    }
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    stopAll();
    controllers.forEach(controller => controller.abort());
    controllers.clear();
    cache.clear();
  }
  const api = { prepare, start, release, stopAll, destroy };
  Object.defineProperty(api, 'state', { enumerable: true, get: () => Object.freeze({
    destroyed, activeVoices: Array.from(voices).filter(voice => !voice.released).length,
    releaseTails: Array.from(voices).filter(voice => voice.released).length,
    loading: Array.from(cache.values()).filter(entry => entry.status === 'loading').length,
    cacheEntries: cache.size, ...stats
  }) });
  return Object.freeze(api);
}

const musicPieces=[{"id":"canon-pachelbel","instrument":"cello","clef":"bass","tempo":60,"notes":[{"pitch":"F#3","beats":1},{"pitch":"E3","beats":1},{"pitch":"D3","beats":1},{"pitch":"C#3","beats":1},{"pitch":"B2","beats":1},{"pitch":"A2","beats":1},{"pitch":"B2","beats":1},{"pitch":"C#3","beats":1},{"pitch":"D3","beats":1},{"pitch":"C#3","beats":1},{"pitch":"B2","beats":1},{"pitch":"A2","beats":1},{"pitch":"G2","beats":1},{"pitch":"F#2","beats":1},{"pitch":"G2","beats":1},{"pitch":"E2","beats":1},{"pitch":"F#3","beats":1},{"pitch":"E3","beats":1},{"pitch":"D3","beats":1},{"pitch":"C#3","beats":1},{"pitch":"B2","beats":1},{"pitch":"A2","beats":1},{"pitch":"B2","beats":1},{"pitch":"C#3","beats":1},{"pitch":"D3","beats":1},{"pitch":"C#3","beats":1},{"pitch":"B2","beats":1},{"pitch":"A2","beats":1},{"pitch":"G2","beats":1},{"pitch":"F#2","beats":1},{"pitch":"G2","beats":1},{"pitch":"E2","beats":1}]},{"id":"bach-cello-suite-1","instrument":"cello","clef":"bass","tempo":60,"notes":[{"pitch":"G2","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"A3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"A3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"G3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"A3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"G3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"G3","beats":0.5},{"pitch":"G2","beats":0.5},{"pitch":"G3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"A3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"G3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"F#3","beats":0.5}]},{"id":"carol-of-the-bells","instrument":"violin","clef":"treble","tempo":60,"notes":[{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1},{"pitch":"Bb4","beats":1},{"pitch":"A4","beats":0.5},{"pitch":"Bb4","beats":0.5},{"pitch":"G4","beats":1}]},{"id":"fur-elise","instrument":"piano","clef":"treble","tempo":60,"notes":[{"pitch":"E5","beats":0.5},{"pitch":"D#5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"D#5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"B4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"A4","beats":1,"restAfter":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"B4","beats":1,"restAfter":0.5},{"pitch":"E4","beats":0.5},{"pitch":"G#4","beats":0.5},{"pitch":"B4","beats":0.5},{"pitch":"C5","beats":1,"restAfter":0.5},{"pitch":"E4","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"D#5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"D#5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"B4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"A4","beats":1,"restAfter":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"B4","beats":1,"restAfter":0.5},{"pitch":"E4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"B4","beats":0.5},{"pitch":"A4","beats":2}]},{"id":"bach-prelude-c","instrument":"piano","clef":"treble","tempo":60,"notes":[{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"D4","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"D4","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"A4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"D4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"D5","beats":0.5},{"pitch":"F5","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"C4","beats":0.5},{"pitch":"E4","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5},{"pitch":"G4","beats":0.5},{"pitch":"C5","beats":0.5},{"pitch":"E5","beats":0.5}]},{"id":"mountain-king","instrument":"bassoon","clef":"bass","tempo":60,"notes":[{"pitch":"B2","beats":0.5},{"pitch":"C#3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"F#3","beats":1},{"pitch":"E#3","beats":0.5},{"pitch":"C#3","beats":0.5},{"pitch":"E#3","beats":1},{"pitch":"E3","beats":0.5},{"pitch":"C3","beats":0.5},{"pitch":"E3","beats":1},{"pitch":"B2","beats":0.5},{"pitch":"C#3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"E3","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"B3","beats":0.5},{"pitch":"A3","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"D3","beats":0.5},{"pitch":"F#3","beats":0.5},{"pitch":"A3","beats":2}]}];
    const quizLifecycle=new AbortController();
    const pieceSelect=root.querySelector('#piece-select');
    const feedback=root.querySelector('#demo-feedback'),soundStatus=root.querySelector('#sound-status'),replayButton=root.querySelector('#replay-piece'),progress=root.querySelector('#demo-progress'),question=root.querySelector('#quiz-question');
    const buttonBox=root.querySelector('.note-buttons');
    const instrumentLabel=root.querySelector('#piece-instrument');
    let selectedPiece=musicPieces.find(piece=>piece.id===pieceSelect.value)||musicPieces[0];
    let quizMelody=[],buttons=[],current=0,quizComplete=false,replayTimer=null,replayRun=0,replaying=false;
    let gesture=null,quizGeneration=0,skipClickUntil=0;
    const replayReleases=new Set();
    const quizAudio=createQuizAudio({getContext:()=>{
      const AC=window.AudioContext||window.webkitAudioContext;
      if(!AC)throw new Error('Audio unavailable');
      audioContext=audioContext||new AC();return audioContext;
    }});
    const letterNames={C:'Do',D:'Ré',E:'Mi',F:'Fa',G:'Sol',A:'La',B:'Si'};
    const letterSteps={C:0,D:1,E:2,F:3,G:4,A:5,B:6};
    const semitones={C:0,D:2,E:4,F:5,G:7,A:9,B:11};
    function makeNote(pitch,beats=1){
      const [,letter,accidental,octaveText]=pitch.match(/^([A-G])([#b]?)(-?\d+)$/);
      const octave=Number(octaveText),midi=(octave+1)*12+semitones[letter]+(accidental==='#'?1:accidental==='b'?-1:0);
      const top=selectedPiece.clef==='bass'?26:38;
      const y=40+(top-(octave*7+letterSteps[letter]))*10;
      const alteration=accidental==='#'?'♯':accidental==='b'?'♭':'';
      return {id:pitch,pitch,letter,accidental,octave,midi,hz:440*2**((midi-69)/12),name:letterNames[letter]+alteration,y,beats};
    }
    function pieceOption(){return pieceSelect.options[pieceSelect.selectedIndex]}
    function pieceTitle(){return pieceOption().textContent}
    const currentNote=()=>quizMelody[current];
    function answerNote(name){
      const target=currentNote();
      const symbol=name.endsWith('♯')?'#':name.endsWith('♭')?'b':'';
      const natural=name.replace(/[♯♭]/g,'');
      const letter=Object.keys(letterNames).find(key=>letterNames[key]===natural);
      return [target.octave-1,target.octave,target.octave+1].map(octave=>makeNote(letter+symbol+octave)).reduce((closest,note)=>Math.abs(note.midi-target.midi)<Math.abs(closest.midi-target.midi)?note:closest);
    }
    function noteHint(note){
      const clef=selectedPiece.clef==='bass'?strings["cle_de_fa"]:strings["cle_de_sol"];
      let position;
      if(note.y>=40&&note.y<=120){
        const positions={120:strings["la_premiere_ligne_en_partant_du_bas"],110:strings["le_premier_espace_en_partant_du_bas"],100:strings["la_deuxieme_ligne_en_partant_du_bas"],90:strings["le_deuxieme_espace_en_partant_du_bas"],80:strings["la_ligne_du_milieu"],70:strings["le_troisieme_espace_en_partant_du_bas"],60:strings["la_quatrieme_ligne_en_partant_du_bas"],50:strings["le_quatrieme_espace_en_partant_du_bas"],40:strings["la_cinquieme_ligne_tout_en_haut"]};
        position=positions[note.y];
      }else if(note.y===130)position=strings["juste_sous_la_portee"];
      else if(note.y===140)position=strings["la_premiere_petite_ligne_sous_la_portee"];
      else if(note.y===150)position=strings["sous_la_premiere_petite_ligne"];
      else if(note.y===30)position=strings["juste_au_dessus_de_la_portee"];
      else if(note.y===20)position=strings["la_premiere_petite_ligne_au_dessus_de"];
      else position=note.y>120?strings["sous_la_portee_sur_les_lignes_supplementaires"]:strings["au_dessus_de_la_portee_sur_les"];
      return clef+', '+position+'.'+(note.accidental==='#'?strings["le_diese_monte_la_note_dun_demi"]:note.accidental==='b'?strings["le_bemol_descend_la_note_dun_demi"]:'');
    }
    function drawNote(note){
      const svg=root.querySelector('.staff'),head=root.querySelector('#note-head'),stem=root.querySelector('#note-stem'),ledger=root.querySelector('#ledger-lines');
      head.setAttribute('cy',note.y);head.setAttribute('transform',`rotate(-18 216 ${note.y})`);
      const down=note.y<=80;stem.setAttribute('x1',down?205:227);stem.setAttribute('x2',down?205:227);stem.setAttribute('y1',note.y+(down?4:-4));stem.setAttribute('y2',note.y+(down?64:-64));
      ledger.replaceChildren();
      const lines=[];for(let y=140;y<=note.y;y+=20)lines.push(y);for(let y=20;y>=note.y;y-=20)lines.push(y);
      lines.forEach(y=>{const line=document.createElementNS('http://www.w3.org/2000/svg','line');line.setAttribute('x1','194');line.setAttribute('x2','238');line.setAttribute('y1',y);line.setAttribute('y2',y);ledger.append(line)});
      const accidental=root.querySelector('#note-accidental');accidental.textContent=note.accidental==='#'?'♯':note.accidental==='b'?'♭':'';accidental.setAttribute('y',note.y+11);
      root.querySelector('#staff-clef').style.display=selectedPiece.clef==='bass'?'none':'';
      root.querySelector('#bass-clef').style.display=selectedPiece.clef==='bass'?'':'none';
      svg.setAttribute('aria-label',strings["note_en"]+noteHint(note));
    }
    function setNote(message=''){
      buttons.forEach(button=>{button.disabled=false;button.classList.remove('correct','incorrect','is-playing')});
      drawNote(currentNote());root.querySelector('#demo-count').textContent=String(current+1).padStart(2,'0')+' / '+quizMelody.length;
      progress.value=current;progress.max=quizMelody.length;question.textContent=strings["quelle_est_cette_note"];
      feedback.textContent=message||strings["un_indice"]+noteHint(currentNote());
      soundStatus.textContent=strings["gardez_le_doigt_appuye_pour_prolonger_le"];
    }
    function setReplayControls(playing){
      replaying=playing;
      root.querySelector('#listen').disabled=playing;root.querySelector('#staff-listen').disabled=playing;
      buttons.forEach(button=>button.disabled=playing||quizComplete);
      root.querySelector('.staff-hint').textContent=playing?strings["votre_melodie_note_apres_note"]:strings["appuyez_sur_la_portee_pour_ecouter"];
      replayButton.textContent=playing?strings["arreter_la_melodie"]:quizComplete?strings["reecouter_la_melodie"]:strings["ecouter_lextrait"];
    }
    function cancelGesture(){
      if(!gesture)return;
      const held=gesture;gesture=null;
      held.element.classList.remove('is-playing');
      if(held.voice)quizAudio.release(held.voice);
      if(held.kind==='pointer'){try{held.element.releasePointerCapture(held.pointerId)}catch(error){}}
    }
    function stopQuizSound(){
      quizGeneration++;cancelGesture();quizAudio.stopAll();
    }
    function stopReplay(){
      if(!replaying)return;
      clearTimeout(replayTimer);replayTimer=null;replayRun++;
      replayReleases.forEach(timer=>clearTimeout(timer));replayReleases.clear();
      stopQuizSound();setReplayControls(false);drawNote(currentNote());
      soundStatus.textContent=strings["lecture_arretee"];
    }
    function stopAllSounds(){stopReplay();stopQuizSound();toneRequest++;stopVoice()}
    function playQuizNote(note){
      if(!soundEnabled){soundStatus.textContent=strings["le_son_est_coupe_vous_pouvez_le"];return null}
      toneRequest++;stopVoice();
      try{
        const voice=quizAudio.start(note,{instrument:selectedPiece.instrument,velocity:.75});
        quizAudio.prepare(selectedPiece.instrument,quizMelody).catch(()=>{});
        if(voice.ready)voice.ready.catch(()=>{soundStatus.textContent=strings["le_son_nest_pas_disponible_ici_vous"]});
        soundStatus.textContent=strings["vous_jouez"]+note.name+' · '+instrumentLabel.textContent;
        return voice;
      }catch(error){soundStatus.textContent=strings["le_son_nest_pas_disponible_ici_vous"];return null}
    }
    function completeQuiz(){
      quizComplete=true;progress.value=quizMelody.length;question.textContent=strings["vous_avez_joue_votre_morceau"];
      feedback.textContent=quizMelody.length+strings["notes_trouvees_bravo_reecoutez_votre_extrait_de"]+pieceTitle()+'.';
      buttons.forEach(button=>button.disabled=true);replayButton.textContent=strings["reecouter_la_melodie"];
    }
    function submitAnswer(button,note){
      if(quizComplete||replaying)return;
      const expected=currentNote();
      if(note.name===expected.name){
        if(current===quizMelody.length-1){button.classList.add('correct');completeQuiz()}
        else{current++;setNote(strings["bravo_cetait_un"]+expected.name.toLowerCase()+strings["trouvez_la_note_suivante"])}
      }else{button.classList.add('incorrect');feedback.textContent=strings["essayez_encore"]+noteHint(expected)}
    }
    function startGesture(element,event,kind){
      if(element.disabled||gesture||replaying)return;
      const answer=element.classList.contains('note-button');
      const note=answer?answerNote(element.dataset.note):currentNote();
      gesture={element,note,answer,kind,pointerId:event.pointerId,generation:quizGeneration,voice:playQuizNote(note),x:event.clientX,y:event.clientY};
      showClickNote(event,note);
      element.classList.add('is-playing');
      if(kind==='pointer'){try{element.setPointerCapture(event.pointerId)}catch(error){}}
    }
    function finishGesture(event,cancel=false){
      if(!gesture)return;
      const held=gesture;
      if(held.kind==='pointer'&&event.pointerId!==undefined&&held.pointerId!==event.pointerId)return;
      gesture=null;held.element.classList.remove('is-playing');
      if(held.voice)quizAudio.release(held.voice);
      skipClickUntil=performance.now()+500;
      if(held.kind==='pointer'){
        const box=held.element.getBoundingClientRect();
        cancel=cancel||event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom;
      }
      if(!cancel&&held.answer&&held.generation===quizGeneration)submitAnswer(held.element,held.note);
    }
    function bindPlayable(element){
      element.addEventListener('pointerdown',event=>{if(event.button!==0||event.isPrimary===false)return;startGesture(element,event,'pointer')});
      element.addEventListener('pointerup',event=>finishGesture(event));
      element.addEventListener('pointercancel',event=>finishGesture(event,true));
      element.addEventListener('lostpointercapture',event=>{if(gesture?.element===element)finishGesture(event,true)});
      element.addEventListener('keydown',event=>{
        if(event.key!==' '&&event.key!=='Enter')return;
        event.preventDefault();if(!event.repeat)startGesture(element,{target:element,clientX:0,clientY:0,detail:0},'keyboard');
      });
      element.addEventListener('keyup',event=>{
        if(event.key!==' '&&event.key!=='Enter')return;
        event.preventDefault();if(gesture?.kind==='keyboard')finishGesture(event);
      });
      element.addEventListener('blur',()=>{if(gesture?.element===element)finishGesture({},true)});
      element.addEventListener('click',event=>{
        if(performance.now()<skipClickUntil||event.detail>0||element.disabled||replaying)return;
        const answer=element.classList.contains('note-button'),note=answer?answerNote(element.dataset.note):currentNote();
        const voice=playQuizNote(note);showClickNote(event,note);
        if(voice)setTimeout(()=>quizAudio.release(voice),320);
        if(answer)submitAnswer(element,note);
      });
    }
    function configurePiece(){
      stopAllSounds();selectedPiece=musicPieces.find(piece=>piece.id===pieceSelect.value)||musicPieces[0];
      quizMelody=selectedPiece.notes.map(note=>({...makeNote(note.pitch,note.beats),restAfter:note.restAfter||0}));current=0;quizComplete=false;
      const option=pieceOption();instrumentLabel.textContent=option.dataset.instrumentLabel;
      root.querySelector('#piece-label').textContent=pieceTitle()+' · '+option.dataset.composer;
      root.querySelector('#piece-excerpt').textContent=option.dataset.excerpt;
      root.querySelector('#piece-clef').textContent=selectedPiece.clef==='bass'?strings["cle_de_fa_2"]:strings["cle_de_sol_2"];
      const names=Object.values(letterNames);
      const accidentals=[...new Set(quizMelody.filter(note=>note.accidental).map(note=>note.name))];
      names.push(...accidentals);
      buttonBox.replaceChildren();
      names.forEach(name=>{const button=document.createElement('button');button.type='button';button.className='note-button';button.dataset.note=name;button.setAttribute('data-oonote-ui','');button.textContent=name;buttonBox.append(button);bindPlayable(button)});
      buttons=[...buttonBox.querySelectorAll('.note-button')];setReplayControls(false);setNote();
      if(audioContext)quizAudio.prepare(selectedPiece.instrument,quizMelody).catch(()=>{});
    }
    function replayPiece(){
      if(replaying){stopReplay();return}
      if(!soundEnabled){soundStatus.textContent=strings["activez_le_son_en_bas_de_page"];return}
      stopQuizSound();toneRequest++;stopVoice();
      const run=++replayRun;let index=0,elapsed=0,anchor=performance.now();setReplayControls(true);
      const step=()=>{
        if(run!==replayRun||!soundEnabled)return;


        if(performance.now()-(anchor+elapsed)>250)anchor=performance.now()-elapsed;
        const note=quizMelody[index++];drawNote(note);const voice=playQuizNote(note);
        const noteDuration=note.beats*60000/selectedPiece.tempo;
        const interval=(note.beats+note.restAfter)*60000/selectedPiece.tempo;
        const releaseTimer=setTimeout(()=>{replayReleases.delete(releaseTimer);if(run===replayRun&&voice)quizAudio.release(voice)},Math.max(100,noteDuration*.8));
        replayReleases.add(releaseTimer);
        soundStatus.textContent=pieceTitle()+' · '+index+' / '+quizMelody.length;
        elapsed+=interval;
        const nextDelay=Math.max(0,anchor+elapsed-performance.now());
        if(index<quizMelody.length)replayTimer=setTimeout(step,nextDelay);
        else replayTimer=setTimeout(()=>{if(run!==replayRun)return;replayTimer=null;setReplayControls(false);drawNote(currentNote());soundStatus.textContent=strings["a_vous_de_jouer"]},nextDelay+650);
      };
      step();
    }
    pieceSelect.addEventListener('change',configurePiece);
    pieceSelect.addEventListener('pointerdown',()=>{quizAudio.prepare(selectedPiece.instrument,quizMelody).catch(()=>{})},{once:true});
    root.querySelector('#restart-quiz').addEventListener('click',configurePiece);
    bindPlayable(root.querySelector('#listen'));bindPlayable(root.querySelector('#staff-listen'));
    replayButton.addEventListener('click',replayPiece);
    window.addEventListener('blur',stopAllSounds,{signal:quizLifecycle.signal});
    window.addEventListener('pagehide',stopAllSounds,{signal:quizLifecycle.signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stopAllSounds()},{signal:quizLifecycle.signal});
    function destroyQuiz(){stopAllSounds();quizAudio.destroy();quizLifecycle.abort()}
    configurePiece();

    root.addEventListener('click',event=>{
      const target=event.target instanceof Element?event.target:null;if(!target||!target.hasAttribute('data-oonote-ui')||target.closest('#sound-toggle'))return;
      if(target.closest('.demo-card'))return;
      stopAllSounds();const note=nextMelodyNote();showClickNote(event,note);playTone(note,note.duration).catch(()=>{});
    },{capture:true});

  
    document.addEventListener('shopify:section:unload',event=>{
      if(!event.target.contains(root))return;
      destroyQuiz();
      if(audioContext)audioContext.close().catch(()=>{});
      lifecycle.abort();
    },{signal:lifecycle.signal});
  }
  document.querySelectorAll('[data-oonote-home]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>{
    event.target.querySelectorAll('[data-oonote-home]').forEach(initialize);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oonote-reviews"]) return;
  try {
    
(() => {
  const initForm = () => {
    const form = document.querySelector('#oonote-review-form');
    if (!form || form.dataset.reviewReady) return;
    form.dataset.reviewReady = 'true';
    const message = form.querySelector('#oonote-review-message');
    const encoded = form.querySelector('[data-review-encoded-body]');
    const options = [...form.querySelectorAll('input[name="oonote_rating"]')];
    const hint = form.querySelector('[data-review-rating-hint]');
    const previous = /^Note OONOTE : ([1-5])\/5\r?\n\r?\n([\s\S]*)$/.exec(encoded.value);
    if (previous) {
      options.find(option => option.value === previous[1]).checked = true;
      message.value = previous[2];
    }
    const sync = () => {
      const selected = options.find(option => option.checked);
      const rating = selected ? Number(selected.value) : 0;
      options.forEach(option => option.closest('label').classList.toggle('is-filled', Number(option.value) <= rating));
      hint.textContent = rating ? hint.dataset.selectedLabel.replace('OONOTE_AVERAGE', String(rating)) : hint.dataset.emptyLabel;
      encoded.value = rating ? `Note OONOTE : ${rating}/5\n\n${message.value.trim()}` : message.value.trim();
    };
    options.forEach(option => option.addEventListener('change', sync));
    message.addEventListener('input', sync);
    form.addEventListener('submit', event => {
      message.setCustomValidity(message.value.trim() ? '' : message.validationMessage || form.querySelector('label[for="oonote-review-message"]').textContent);
      sync();
      if (!form.reportValidity()) event.preventDefault();
    });
    message.addEventListener('input', () => message.setCustomValidity(''));
    sync();
    form.querySelector('button[type="submit"]').disabled = false;
    form.querySelector('[data-review-feedback]')?.focus();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initForm, { once: true });
  else initForm();
  document.addEventListener('shopify:section:load', initForm);
})();

  } catch(e) { console.error(e); }
})();
})();
